import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL

const UserService = {
  actions: {
    fetchCategories ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/categories',
          method: 'GET'
        })
          .then(resp => {
            const categories = resp.data.categories
            commit('api_success')
            resolve(resp)
            return categories
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchBrandings ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/brandings',
          method: 'GET'
        })
          .then(resp => {
            const brandings = resp.data.brandings
            commit('api_success')
            resolve(resp)
            return brandings
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchPresentations ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/presentations',
          method: 'GET'
        })
          .then(resp => {
            const presentations = resp.data.presentations
            commit('api_success')
            resolve(resp)
            return presentations
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchProducts ({ commit, dispatch }, categoryID) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/products/' + categoryID,
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
            return resp.data
          })
          .catch(err => {
            if (err.response.status === 404) { commit('api_error') } else { dispatch('catchHandler') }
            reject(err)
          })
      })
    },
    fetchImages ({ commit, dispatch }, productID) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/images/' + productID,
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
            return resp.data
          })
          .catch(err => {
            if (err.response.status === 404) { commit('api_error') } else { dispatch('catchHandler') }
            reject(err)
          })
      })
    },
    fetchPhotos ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/photos',
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
            return resp.data
          })
          .catch(err => {
            if (err.response.status === 404) { commit('api_error') } else { dispatch('catchHandler') }
            reject(err)
          })
      })
    },
    fetchPhotoImages ({ commit, dispatch }, {photoID, category}) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/photo-images/' + photoID,
          method: 'GET',
          params: {category}
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
            return resp.data
          })
          .catch(err => {
            if (err.response.status === 404) { commit('api_error') } else { dispatch('catchHandler') }
            reject(err)
          })
      })
    },
    fetchAdvertisements ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/advertisements',
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchSellSheetCategories ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/sell-sheet-categories',
          method: 'GET'
        })
          .then(resp => {
            const categories = resp.data.categories
            commit('api_success')
            resolve(resp)
            return categories
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchSellSheets ({ commit, dispatch }, categoryID) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/sell-sheets/' + categoryID,
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchPublicRelations ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/public-relations',
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchVideos ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/videos',
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchC1868Categories ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/c1868-categories',
          method: 'GET'
        })
          .then(resp => {
            const categories = resp.data.categories
            commit('api_success')
            resolve(resp)
            return categories
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchC1868s ({ commit, dispatch }, {categoryID, subCategory}) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/c1868s/' + categoryID,
          method: 'GET',
          params: {sub_category: subCategory}
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchDownload ({ commit, dispatch }, params) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/download/' + params.type + '/' + params.id,
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
            return resp.data.modal
          })
          .catch(err => {
            if (err.response.status === 404) { commit('api_error') } else { dispatch('catchHandler') }
            reject(err)
          })
      })
    },
    insertDownload ({ commit, dispatch }, params) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/download/' + params.type + '/' + params.id + '/insert?nocache=' + new Date().getTime(),
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
            return resp.data.modal
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    search ({ commit, dispatch }, search) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/search',
          data: {search: search},
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
            return resp.data
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    postHelp ({ commit, dispatch }, params) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/help',
          data: params,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
            return resp.data
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    }
  }
}

export default UserService



// WEBPACK FOOTER //
// ./src/services/userService.js